import React from "react";
import { TYPE_PROFILE } from "../../constants/page-types";
import { useEventContext } from "../../context/EventContext";
import { ModalContextProvider } from "../../context/ModalContext";
import PageContainer from "../../components/PageContainer";
import UserProfileInfo from "../../components/User/UserProfile/UserProfileInfo";
import UserProfileBalance from "../../components/User/UserProfile/UserProfileBalance";

import "./style.scss";

export default () => {
    const { event, pages } = useEventContext();

    const page = pages.find(({ type }) => type === TYPE_PROFILE);
    const pageSettings = page?.settings || {};

    return (
        <PageContainer>
            <ModalContextProvider>
                <section className="profile-page">
                    <div className="profile-page__block">
                        <UserProfileInfo
                            pageSetting={pageSettings}
                            event={event}
                        />
                        {event.moduleShop.enabled && (
                            <UserProfileBalance />
                        )}
                    </div>
                </section>
            </ModalContextProvider>
        </PageContainer>
    );
}
